export default __webpack_public_path__ + "static/Image1-3499c4261ff265bff62f41e78f07a76a.jpg";